import React from 'react';
import { useNavigate } from 'react-router-dom';
import not4 from '../../assets/notFound.gif';
import Footer from '../../Components/Footer/Footer';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="h-[85vh] flex justify-center items-center flex-col">
        <img src={not4} alt="Not Found" height={450} width={450} />
        <button
          onClick={() => navigate('/')}
          className="p-3 border-2 text-white border-primary rounded text-secondary mt-5"
        >
          Back To Home
        </button>
      </div>

      <Footer />
    </>
  );
};

export default NotFound;
